import { defineComponent as _defineComponent } from 'vue'
type Item = Record<string, unknown>;


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseOptions',
  props: {
    items: null,
    vKey: null,
    isEmpty: { type: Boolean, default: true },
    show: { type: Boolean, default: true },
    dividerAfterIndex: { default: -1 },
    pinnedIndex: { default: -1 }
  },
  emits: [
    'select',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { items: Item[] | number, vKey?: string | number, isEmpty: boolean, show: boolean, dividerAfterIndex: number, pinnedIndex: number }




const handleSelect = (item: Item, index: number): void => {
    emits('select', { item, index });
};

return { __sfc: true,props, emits, handleSelect }
}

})